<template>
  <div>
    <!-- <el-form :inline="true" style="margin-top:20px">
      <el-form-item>
          <el-button @click="addMatch" >新增</el-button>
      </el-form-item>
    </el-form> -->
    <el-form :inline="true" style="padding-top:0;margin-top: 20px" :model="searchForm">
      <el-form-item label="搜索：">
        <el-input size="medium" placeholder="请输入产品名称" v-model="searchForm.SCNAME" @blur="checkBlur"
          @keyup.enter.native="handleSearch"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="medium" type="primary" id="search" @click="handleSearch">筛选</el-button>
        <el-button size="medium" @click="batchPurchaseOrder()">一键转换采购</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" @selection-change="handleSelectionChange" stripe border style="width: 100%">
          <el-table-column type="selection" width="55" :selectable="checkSelectable"></el-table-column>
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="FCNAME" label="大类名称"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COUNT" @change="setActualNumber(scope.row)" :disabled="btnStatus > 1"
                clearable>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="MIN_PRICE" label="当前最低采购价"></el-table-column>
          <el-table-column prop="MAX_PRICE" label="当前最高采购价"></el-table-column>
          <el-table-column prop="MIN_SUBMIT_PRICE" label="比价最低报价" v-if="this.btnStatus === 3"></el-table-column>
          <el-table-column prop="MIN_SUPPLIER_NAME" label="最低报价供应商" v-if="this.btnStatus === 3"></el-table-column>
          <el-table-column prop="MAX_SUBMIT_PRICE" label="比价最高报价" v-if="this.btnStatus === 3"></el-table-column>
          <el-table-column prop="MAX_SUPPLIER_NAME" label="最高报价供应商" v-if="this.btnStatus === 3"></el-table-column>
          <el-table-column prop="action" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" :disabled="btnStatus > 1" @click="subData(scope.row)">修改</el-button>
              <el-button type="text" size="small" :disabled="btnStatus > 1" @click="delData(scope.row)">删除</el-button>
              <!-- =======================一键生成采购订单============ -->
              <el-button v-preventReClick type="text" size="small" @click="supplierPurchaseOrder(scope.row)"
                :disabled="btnStatus != 3">一键生成采购订单</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <div class="pagination_box" v-show="totalCount > 10">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
    <div style="clear:both"></div>
    <el-row style="margin-top:20px">
      <el-col :xl="{ span: 1, offset: 22 }" :lg="{ span: 1, offset: 22 }" :md="{ span: 2, offset: 21 }"
        style="padding-left:4px">
        <el-button @click="submitAll()" :disabled="btnStatus > 1">全部确认</el-button>
      </el-col>
    </el-row>
    <!-- 新增模态框 -->
    <el-dialog :visible.sync="addDialog" @close="addDialog = false" title="新增比价" width="400px" center>
      <el-form ref="addForm" v-model="addForm" :inline="true">
        <el-form-item label="产品名称：">
          <el-autocomplete v-model="addForm.PRODUCT_NAME" :fetch-suggestions="getProductList" placeholder="请输入内容"
            @select="productSelect" clearable @blur="checkValue()"></el-autocomplete>
        </el-form-item>
        <el-form-item label="订购数量：">
          <label slot="label">订购数量：</label>
          <el-input v-model="addForm.COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="addDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="submitAddPrice">确认</el-button>
      </div>
    </el-dialog>
    <!-- 生成采购订单 -->
    <el-dialog :visible.sync="supplierPurchaseOrderDialog" @close="closeSupplierPurchaseOrderDialog" title="生成采购订单"
      width="800px" center>
      <el-form ref="orderForm" v-model="orderForm" :inline="true">
        <el-form-item label="配送日期：" :label-width="formLableWidth">
          <el-date-picker v-model="orderForm.SEND_DAY" align="right" type="date" :picker-options="pickerOptions1"
            placeholder="请选择配送日期" value-format="yyyy-MM-dd" style="width: 100%">
          </el-date-picker>
          <label style=" display:block; margin-left:-82px; margin-top:10px; margin-bottom:-15px;">低价供应商：</label>
        </el-form-item>
        <el-table :data="supplierList" style="width: 100%" border stripe>
          <el-table-column label="序号" width="80" type="index"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商名称"></el-table-column>
          <el-table-column prop="SINGEL_TOTAL_FEE" label="预计采购总金额"></el-table-column>
          <el-table-column prop="action" label="操作">
            <!--  prop="" -->
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="submitPurchaseOrder(scope.row)">立即转换</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>
    <!-- 批量一键转换采购 -->
    <el-dialog :visible.sync="batchPurchaseOrderDialog" @close="closeBatchPurchaseOrderDialog" title="生成采购订单"
      width="800px" center>
      <el-form ref="batchOrderForm" v-model="batchOrderForm" :inline="true">
        <el-form-item label="配送日期：" :label-width="formLableWidth">
          <el-date-picker v-model="batchOrderForm.SEND_DAY" align="right" type="date" :picker-options="pickerOptions1"
            placeholder="请选择配送日期" value-format="yyyy-MM-dd" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="batchOrder">批量转换</el-button>
        </el-form-item>
        <br>
        <label>低价供应商：</label>
        <el-table :data="batchSupplierList" style="width: 100%" border stripe>
          <el-table-column label="序号" width="80" type="index"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商名称"></el-table-column>
          <el-table-column prop="SINGEL_TOTAL_FEE" label="预计采购总金额"></el-table-column>
          <el-table-column prop="action" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="submitBatchPurchaseOrder(scope.row)">立即转换</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getActionFun } from 'api/login';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      PAGE_ID: '1030201', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 103020101: 0 },
      searchForm: {},
      addForm: {
        PRODUCT_NAME: '',
        PRODUCT_CODE: '',
      },
      CHANGE_DATA_LIST: [
      ],
      orderForm: {
      },
      batchOrderForm: {
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      formLableWidth: '100px',
      supplierList: [],
      batchSupplierList: [],
      addDialog: false,
      supplierPurchaseOrderDialog: false,
      batchPurchaseOrderDialog: false,
      tableData: [],
      productArray: [],
      PRODUCT_COUNT: '',
      PRODUCT_CODE: 0,
      MIN_SUBMIT_PRICE: '',
      productList: [],
      totalCount: 0,
      pageSize: 15,
      currentPage: 1,
      submitCount: 0,
      //   提交状态
      btnStatus: Number(this.$route.params.status),
      informationList: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.getInputList();
    this.queryBeforeFun();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params)
        .then((result) => {
          if (result.length !== 0) {
            this.forMenu(result, this.fun_dic);
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // 获取录入数据接口
    getInputList() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 23,
        COMPARE_ID: Number(this.$route.params.id),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SCNAME) {
        params.SCNAME = this.searchForm.SCNAME;
      }
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        } else {
          this.tableData = res[0].PRODUCT_DATA;
          this.totalCount = res[0].TOTAL_COUNT;
        }
        console.log(this.tableData);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 搜索
    checkBlur() {
      if (!this.searchForm.SCNAME) {
        this.searchForm.SCNAME = '';
      }
    },
    handleSearch() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 23,
        COMPARE_ID: Number(this.$route.params.id),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SCNAME) {
        params.SCNAME = this.searchForm.SCNAME;
      }
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
          this.totalCount = 0;
        } else {
          this.tableData = res[0].PRODUCT_DATA;
          this.totalCount = res[0].TOTAL_COUNT;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增产品
    addMatch() {
      this.addDialog = true;
    },
    // 获取产品
    getProductList(queryString, callBack) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 6,
        PRODUCT_NAME: queryString,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        result = JSON.parse(JSON.stringify(result).replace(/NAME/g, 'value'));
        callBack(result);
      })
        .catch((error) => {
          console.log(error);
        });
    },
    productSelect(item) {
      this.addForm.PRODUCT_CODE = item.PRODUCT_CODE;
    },
    checkValue() {
      if (!this.addForm.PRODUCT_NAME) {
        this.addForm.PRODUCT_CODE = '';
      }
    },
    // 提交新增产品
    submitAddPrice() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 20,
        F_CAT_ID: Number(this.$route.params.id),
        PRODUCT_CODE: this.addForm.PRODUCT_CODE,
        PRODUCT_COUNT: this.addForm.COUNT,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addDialog = false;
        this.addForm = {};
        this.getInputList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出模板
    // downLoadSKU () {
    //   window.location.href = 'https://service.linkda.com.cn/file/templates/leadinginprice.xlsx';
    // },
    // 设置当前产品的实收数量
    currentActualNumber(row) {
      return row.PRODUCT_COUNT;
    },
    // 分页
    handleCurrentChange(e) {
      this.currentPage = e;
      this.getInputList();
    },
    // 修改某行数据
    subData(row) {
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(row.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正确的订购数量', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 4,
        DETAIL_ID: row.DETAIL_ID,
        PRODUCT_COUNT: row.PRODUCT_COUNT,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 删除某行数据
    delData(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 5,
        DETAIL_ID: row.DETAIL_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.getInputList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 改变实收数量触发
    setActualNumber(row) {
      if (!(/\d/.test(row.PRODUCT_COUNT))) {
        this.$message.show({ text: '请输入正确的订购数量', type: 'warning' });
        return false;
      }
      this.submitCount = Number(row.PRODUCT_COUNT);
      console.log(this.submitCount, '改变的数据');
      console.log(row.PRODUCT_CODE, '改变的数量的产品编码');
      this.CHANGE_DATA_LIST.push({ PRODUCT_CODE: row.PRODUCT_CODE, PRODUCT_COUNT: this.submitCount });
      console.log(this.CHANGE_DATA_LIST);
    },
    // 点击全部确认
    submitAll() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 8,
        COMPARE_ID: Number(this.$route.params.id),
      };
      if (this.CHANGE_DATA_LIST.length != 0) {
        params.CHANGE_DATA_LIST = this.CHANGE_DATA_LIST;
      } else {
        params.CHANGE_DATA_LIST = [];
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '全部确认成功', type: 'success' });
        this.$router.go(-1);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 一键生成采购订单弹框
    supplierPurchaseOrder(row) {
      this.PRODUCT_COUNT = row.PRODUCT_COUNT;
      this.PRODUCT_CODE = row.PRODUCT_CODE;
      // 获取供应商
      if (!row.MIN_SUBMIT_PRICE) {
        this.$message.show({ text: '暂未有比价最低报价', type: 'warning' });
        return false;
      }
      this.supplierPurchaseOrderDialog = true;
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 32,
        COMPARE_ID: Number(this.$route.params.id),
        PRODUCT_CODE: row.PRODUCT_CODE,
      };
      http.post(params).then((result) => {
        this.supplierList = result;
        console.log(this.supplierList, '===================报价供应商');
      })
        .catch((error) => {
          console.log(error);
        });
    },
    // 一键生成采购订单
    submitPurchaseOrder(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 31,
        COMPARE_ID: Number(this.$route.params.id),
        SUPPLIER_ID: row.SUPPLIER_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: this.orderForm.SEND_DAY,
        PRODUCT_CODE: this.PRODUCT_CODE,
        PRODUCT_COUNT: this.PRODUCT_COUNT,
        MIN_SUBMIT_PRICE: row.MIN_SUBMIT_PRICE,
      };

      http.post(params).then((res) => {
        this.$message.show({ text: '比价完成', type: 'success' });
        this.supplierPurchaseOrderDialog = false;
        this.getProductList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closeSupplierPurchaseOrderDialog() {
      this.PRODUCT_COUNT = '';
      this.PRODUCT_CODE = 0;
      this.supplierPurchaseOrderDialog = false;
    },
    // 多选
    handleSelectionChange(val) {
      const productList = [];
      val.forEach((item) => { productList.push(item.PRODUCT_CODE); });
      this.productList = productList;
      console.log(this.productList, this.btnStatus, '选中的产品');
    },
    // 比价未完成禁止勾选
    checkSelectable(row) {
      if (this.btnStatus != 3) {
        return false;
      } if (!row.MIN_SUBMIT_PRICE) {
        return false;
      }
      return true;
    },
    // 批量一键转换采购
    batchPurchaseOrder() {
      this.batchPurchaseOrderDialog = true;
      // 批量获取供应商报价
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 33,
        COMPARE_ID: Number(this.$route.params.id),
        PRODUCT_CODE_LIST: this.productList,
      };
      http.post(params).then((result) => {
        this.batchSupplierList = result;
        console.log(this.batchSupplierList, '===================批量报价供应商');
        result.forEach((item) => {
          this.informationList.push({
            PRODUCT_CODE: item.PRODUCT_CODE, PRODUCT_COUNT: item.PRODUCT_COUNT, SUPPLIER_ID: item.SUPPLIER_ID, MIN_SUBMIT_PRICE: item.MIN_SUBMIT_PRICE,
          });
        });
        console.log(this.informationList, '============================相关数据');
      })
        .catch((error) => {
          console.log(error);
        });
    },
    closeBatchPurchaseOrderDialog() {
      this.batchPurchaseOrderDialog = false;
    },
    // 批量一键生成采购订单
    submitBatchPurchaseOrder(row) {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 31,
        COMPARE_ID: Number(this.$route.params.id),
        SUPPLIER_ID: row.SUPPLIER_ID,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SEND_DAY: this.batchOrderForm.SEND_DAY,
        PRODUCT_CODE: row.PRODUCT_CODE,
        PRODUCT_COUNT: row.PRODUCT_COUNT,
        MIN_SUBMIT_PRICE: row.MIN_SUBMIT_PRICE,
      };

      http.post(params).then((res) => {
        this.$message.show({ text: '比价完成', type: 'success' });
        this.getProductList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 批量转换按钮
    batchOrder() {
      const params = {
        SERVICE_ID: '10071',
        OTYPE: 34,
        COMPARE_ID: Number(this.$route.params.id),
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.batchOrderForm.SEND_DAY) {
        const newInformationList = [];
        this.informationList.map((item, index) => {
          newInformationList.push({ ...item, SEND_DAY: this.batchOrderForm.SEND_DAY });
          params.INFORMATION_LIST = newInformationList;
        });
        // this.informationList.push({
        //   SEND_DAY: this.batchOrderForm.SEND_DAY,
        // });
      }
      http.post(params).then((res) => {
        this.$message.show({ text: '比价完成', type: 'success' });
        this.getProductList();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
.pagination_box {
  margin-top: 20px;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/priceManagement/inputData.vue